import classNames from 'classnames';

import styles from '../../../styles/icons/base.module.scss';

interface CircleInvalidProps {
    color?: string;
    className?: string;
}

function CircleInvalid({ color = 'currentColor', className = null }: CircleInvalidProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="45"
            height="45"
            viewBox="0 0 45 45"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M25.875,3.375a22.5,22.5,0,1,0,22.5,22.5A22.422,22.422,0,0,0,25.875,3.375Zm11.25,30.6-3.15,3.15-8.1-8.1-8.1,8.1-3.15-3.15,8.1-8.1-8.1-8.1,3.15-3.15,8.1,8.1,8.1-8.1,3.15,3.15-8.1,8.1Z"
                transform="translate(-3.375 -3.375)"
                fill={color}
            />
        </svg>
    );
}

export default CircleInvalid;
